/* import __COLOCATED_TEMPLATE__ from './option-radio-dropdown-item.hbs.js'; */
var _dec, _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';

/*
  Upsell::OptionRadioDropdownItem

  This component is similar to Upsell::OptionCheckboxDropdownItem. This component
  shows a disabled radio circle instead of a disabled checkbox square for the item.
  This is important for report aesthetic where the other options in the list are radios.

  @param {String} label - option Radio label
  @param {String} vertical - The vertical that is using the tooltip.
                             It configures the brand color shown on the components/svgs/plus-badge-filled
                             Available verticals: ['restaurants', 'retail']
  @param {action} optionLabelClicked - action that occurs when the label (including the badge) is clicked
*/
let OptionRadioDropdownItem = (_dec = tagName(''), _dec(_class = class OptionRadioDropdownItem extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "optionLabelClicked", () => {});
  }
}) || _class);
export { OptionRadioDropdownItem as default };